export default __webpack_public_path__ + "static/char-18-anr-8174db2a409c5eb90f0b8a9115a089c2.gif";